import gql from 'graphql-tag';

export const UPDATE_LOOK_REFERENCE_FIELD_FILTER = gql`
  mutation updateLookReferenceFieldFilter($filter: ReferenceFieldFilterInput!, $orderBy: [String]) {
    updateLookReferenceFieldFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
